import React, { useState } from "react";
import Moon from "../resources/vectors/moon.svg";
import Sun from "../resources/vectors/sun.svg";
export default function Toggler() {
  const [mode, setmode] = useState("dark");
  const handleClick = () => {
    let htmlClasses = document.querySelector("html").classList;
    if (mode === "dark") {
      setmode("light");
      htmlClasses.remove("dark");
    } else {
      htmlClasses.add("dark");
      setmode("dark");
    }
  };
  return (
    <button
      onClick={handleClick}
      className="relative h-10 w-10 flex justify-center items-center focus:outline-none "
    >
      <img
        className="w-6 h-6 absolute left-0"
        src={mode === "dark" ? Moon : Sun}
        alt=""
      />
    </button>
  );
}
